<template>
  <Teleport to="body">
    <vue-final-modal
      v-model="showModal"
      classes="modal-container"
      content-class="modal-content month-picker-modal"
      overlay-class="vfm__overlay"
      :click-to-close="true"
      :lock-scroll="true"
      :hide-overlay="false"
      :esc-to-close="true"
      @click:overlay="closeModal"
      @click="handleOutsideClick"
    >
      <div class="p-3" @click.stop>
        <div class="row">
          <div class="col-md-12">
            <b>■年月選択</b>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-center">
            <input class="form-control"
                   type="month"
                   v-model="monthValue"
                   required>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <a href="#" @click.prevent="closeModal">キャンセル</a>
            <span class="mx-2"></span>
            <button class="action-button btn btn-rounded btn-success"
                    @click="monthjump">
              入力した年月を表示
            </button>
          </div>
        </div>
      </div>
    </vue-final-modal>
  </Teleport>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  putmonth: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'onMonth', 'cancel'])

const showModal = ref(false)
const monthValue = ref(null)

watch(() => props.modelValue, (newVal) => {
  showModal.value = newVal
  if (newVal) {
    monthValue.value = props.putmonth
  }
})

watch(() => showModal.value, (newVal) => {
  emit('update:modelValue', newVal)
})

const monthjump = () => {
  if (!monthValue.value) {
    alert('正しい年月を選択してくだい。')
    return
  }
  emit('onMonth', monthValue.value)
  closeModal()
}

const closeModal = () => {
  emit('cancel')
  emit('update:modelValue', false)
}

const handleOutsideClick = (event) => {
  if (event.target.classList.contains('vfm__overlay')) {
    closeModal()
  }
}
</script>

<style>
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 400px;
  z-index: 2001;
}

.content {
  width: 100%;
}

input[type="month"] {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}

.btn-link {
  text-decoration: none;
  color: #6c757d;
}

.btn-link:hover {
  color: #4b5156;
  text-decoration: underline;
}

.month-picker-modal {
  width: 400px !important;
}
</style>
